import { useState } from "react";
import { applyCpfMaskIfNeeded, CPF_LENGTH, extractCpfDigits } from "@/utils/cpf-mask";

import { newResponsibleCpfSchema } from "../../data/schema";

interface NewResponsibleCpfState {
  maskedCpf: string;
  cpfDigits: string;
  cpfError: string | null;
  isCpfReady: boolean;
  handleCpfChange: (value: string) => void;
}

export const useNewResponsibleCpf = (): NewResponsibleCpfState => {
  const [maskedCpf, setMaskedCpf] = useState<string>("");

  const cpfDigits: string = extractCpfDigits(maskedCpf);
  const isComplete: boolean = cpfDigits.length === CPF_LENGTH.WITHOUT_MASK;
  const parsed = newResponsibleCpfSchema.safeParse(maskedCpf);
  const cpfError: string | null =
    isComplete && !parsed.success ? parsed.error.issues[0].message : null;
  const isCpfReady: boolean = parsed.success;

  const handleCpfChange = (value: string): void => {
    setMaskedCpf(applyCpfMaskIfNeeded(extractCpfDigits(value)));
  };

  return { maskedCpf, cpfDigits, cpfError, isCpfReady, handleCpfChange };
};
